/**
 * The viewer title and the video caption used to carry their own font, size,
 * spacing and casing. They now share the site caption settings, so an older
 * theme's values move there the first time it is read (only where the site
 * setting is still empty) and the boxes keep placement and colour only.
 */

const TITLE_MODULES = ['media-title', 'video-caption'];
const LAYERS = ['desktop', 'tablet', 'phone'];

/** Box field, and where it lives on the theme now. */
const MOVED = [
    { field: 'faceId', group: 'fonts', key: 'caption' },
    { field: 'size', group: 'chrome', key: 'captionSize' },
    { field: 'tracking', group: 'chrome', key: 'captionTracking' },
    { field: 'casing', group: 'chrome', key: 'captionCasing' },
];
const FIELDS = MOVED.map((entry) => entry.field);

const isSet = (value) => value != null && value !== '';

function firstValue(modules, field) {
    for (const id of TITLE_MODULES) {
        for (const layer of LAYERS) {
            const value = modules?.[id]?.[layer]?.[field];
            if (isSet(value)) return value;
        }
    }
    return null;
}

function stripped(entry) {
    let changed = false;
    const next = { ...entry };
    Object.keys(next).forEach((layer) => {
        const box = next[layer];
        if (!box || typeof box !== 'object' || !FIELDS.some((field) => field in box)) return;
        const rest = { ...box };
        FIELDS.forEach((field) => delete rest[field]);
        next[layer] = rest;
        changed = true;
    });
    return changed ? next : entry;
}

/**
 * @param {Object} theme
 * @returns {Object} The same theme when there is nothing to move
 */
export function migrateCaptionStyle(theme) {
    const modules = theme?.header?.modules;
    if (!modules || typeof modules !== 'object') return theme;
    if (!TITLE_MODULES.some((id) => modules[id] && stripped(modules[id]) !== modules[id])) return theme;

    const next = { ...theme };
    MOVED.forEach(({ field, group, key }) => {
        const value = firstValue(modules, field);
        if (!isSet(value) || isSet(theme[group]?.[key])) return;
        next[group] = { ...(next[group] || {}), [key]: value };
    });
    const nextModules = { ...modules };
    TITLE_MODULES.forEach((id) => {
        if (nextModules[id]) nextModules[id] = stripped(nextModules[id]);
    });
    next.header = { ...theme.header, modules: nextModules };
    return next;
}
